import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  eng: {
    translation: {
      loading: "Loading...",
      navbar: {
        home: "Home",
        packages: "Packages",
        services: "Services",
        offers: "Offers",
        location: "Location",
        about: "About",
        contact: "Contact",
        testimonials: "Opinions",
        more: "more"
      },
      home: {
        landingPage: {
          slides: [
            {
              header: "Your Trusted laboratory in khorfakkan",
              content: "Central Medical Polyclinic Laboratory",
              labelBtn: "Find Out More"
            },
            {
              header: "Medical Information",
              content: "Accurate medical information is the foundation of prevention. Ensure you obtain correct information to make better health decisions.",
              labelBtn: "Info"
            },
            {
              header: "Special Packages",
              content: "Discover the packages we offer to meet your needs.",
              labelBtn: "Show Package"
            }
          ],
          salesPackage: {
            header: "Our Special Offers",
            discountTag: "{salePercent}% OFF",
            noOffer: "NO OFFER",
            packageButton: "Discover the Offer"
          },
          partnerLogos: { title: "Insurance Partners" }
        },
        info: {
          title: "Why Choose Us?",
          features: [
            {
              title: "We strive for leadership in excellence.",
              description: "We have come a long way on our journey to excellence; our aspirations have risen, and we now strive for leadership in excellence.",
              icon: "running"
            },
            {
              title: "Most Competitive and Productive",
              description: "The most competitive and productive for all stakeholders by continuing our innovative and sustainable working style.",
              icon: "recycle"
            },
            {
              title: "High-Quality Medical Services and Analyses",
              description: "Providing high-quality and accurate medical services and analyses at competitive prices for all stakeholders.",
              icon: "microscope"
            }
          ]
        },
        other: {
          contact: {
            button: "Contact Us",
            divider: "OR",
            socialMediaHeader: "Join our community on social media",
            contactUs: "Contact Us:",
            locationTitle: "Our Location",

          },
          request: {
            tagline: "Contact Us",
            header: "Do you have any questions or suggestions?",
            description: "Send us a message, and we will get back to you with a team of experts",
            button: "Leave a message"
          }
        }
      },
      services: {
        title: "Our Services",
        viewAll: "View All",
        description: "Explore our diverse services",
        service: [
          {
            id: 1,
            name_en: "Medical Information",
            description_en: "Get accurate and up-to-date medical information on various medical conditions .",
            icon: "info",
            path: "/information"
          },
          {
            id: 2,
            name_en: "Laboratory Reports Request",
            description_en: "Submit a request for accurate and comprehensive laboratory reports for all medical tests.",
            icon: "report",
            path: "/reports"
          },
          {
            id: 3,
            name_en: "Home Blood collection request",
            description_en: "Home Blood collection request service allows you to conduct tests at home with comfort and ease.",
            icon: "home",
            path: "/withdraw"
          },
          {
            id: 4,
            name_en: "Packages",
            description_en: "Discover various health packages that cover all testing and treatment needs at competitive prices.",
            icon: "package",
            path: "/package"
          }
        ]
      },
      packages: {
        title: "Available Packages",
        description: "Browse our selection of packages tailored for your needs.",
        noPackages: "No packages available in this category.",
        more: "More",
        offer: "Special Offers",
        bookNow: "Book Now",
        test: "Packages",
        price: "price",
        onSale: "Sale",
        salePrice: "Offer Price",
        saleDuration: "Offer Duration",
        saleTimeLeft: "Time Left",
        home: { more: "All Packages" }
      },
      offer: {
        salesPackage: {
          header: "Our Special Offers",
          description: "Explore our exclusive offers and discounts!",
          discountTag: "Discount",
          offerDuration: "Offer Duration"
        },
        packages: {
          noPackages: "No offers available at the moment.",
          more: "More Details",
          bookNow: "Book Now"
        },
        specialOffer: "Special Offer",
        packageOffer: "Package's Offers",
        start: "start",
        end: "end",
        test: "Packages",
        timeleft: "Time Left",
        offerDuration: "Duration"
      },
      survey: {
        title: "Participate in Our Survey",
        description: "We value your feedback. Please take a moment to complete our survey.",
        start: "Start Survey"
      },
      details: {
        tests: "Packages",
        details: "Details",
        currentPrice: "Current Price",
        originalPrice: "Original Price",
        discount: "Discount",
        offerEndsIn: "Offer Ends In",
        price: "Price",
        bookNow: "Book Now",
        testsNumber: "Packages Number",
        testsNumberSale: "Tests' Sale",
        start: "Start",
        end: "End",
        offerDuration: "Duration",
        timeLeft: "Time Left For end The Sale",
        specialOffer: "Special Offer",
        onSale: "Package's Sale",
        testSale: "Package'S Sale Tests"
      },
      medicalInformation: {
        title: "Medical Information",
        description: "Get updated medical information to improve your health and wellness.",
        generalTab: "General Medical Information",
        weeklyTab: "Weekly Information",
        noData: "No data available",
        availableInfo: "weekly Information",
        noWeeklyInfo: "No information available for this week."
      },
      months: {
        january: "January",
        february: "February",
        march: "March",
        april: "April",
        may: "May",
        june: "June",
        july: "July",
        august: "August",
        september: "September",
        october: "October",
        november: "November",
        december: "December"
      },
      about: {

        title: "About Us",
        description: "Your trusted laboratory in Khorfakkan",
        story: {
          title: "Our Story",
          text: "Our journey began with experience dating back to 2018, when a team of specialized doctors and technicians came together to provide accurate and reliable laboratory services to serve the community of Khorfakkan. Today, we continue this journey through our new laboratory, relying on the latest technology and the highest standards of quality and safety, to deliver precise and rapid results that contribute to supporting medical decision-making and improving community health. Our laboratory is not just a place for testing, but a health partner where we place patients' trust at the forefront of our priorities."
        },
        vision: {
          title: "Our Vision",
          text: "To be the leading and most trusted medical laboratory in Khorfakkan and the region, providing accurate and reliable diagnostic services that enhance healthcare quality and contribute to improving community health through innovation and the highest international standards."
        },

        mission: {
          title: "Our Mission",
          text: "To deliver precise, fast, and reliable laboratory services by utilizing advanced technologies and expert medical staff, while ensuring patient safety, confidentiality, and trust. We aim to support medical decision-making and build long-term health partnerships with our community."
        },

        values: {
          title: "Our Values",
          text: "1. Accuracy & Reliability\n2. Trust & Integrity\n3. Quality & Safety\n4. Teamwork & Expertise\n5. Community Care"
        }

        ,
        "team": { "title": "Our Team" } // English
      },
      "location": {
        "title": "Our Location",
        "description": "We invite you to visit us and explore our services",
        "addressTitle": "Address",
        "country": "United Arab Emirates",
        "governorate": "Emirate of Sharjah",
        "city": "Khorfakkan",
        "scheduleTitle": "Working Hours",
        "BeforeIftar": "Before Iftar",
        "AfterIftar": "After Iftar",
        "schedule": {
          "days": [
            "Saturday",
            "Sunday",
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday"
          ],
          "morning": "Morning Time",
          "evening": "Evening Time",
          "morningTime": "9 AM to 1 PM",
          "eveningTime": "5 PM to 9 PM",
          "daily": "Saturday to Thursday",
          "dailyTime": " 9 AM to 1 PM & 5 PM to 9 PM",
          "monday": "Monday",
          "mondayTime": " 9 AM to 1 PM & 5 PM to 9 PM",
          "friday": "Friday",
          "fridayTime": "OFF"
        },
        "viewPackages": "View Our Packages"
      },
      contact: {
        header: "Contact Us",
        subHeader: "Connect via Social Media",
        locationTitle: "Our Location",
        address: {
          title: "Address",
          location: "Sharjah, Khorfakkan"
        },
        social: {
          facebook: "Facebook",
          whatsapp: "WhatsApp",
          instagram: "Instagram",
          phone: "Phone Number",
          email: "Email",
          address: "Address",
          tiktock: "tiktock",
          snapshat: "Snapchat"
        },
        form: {
          inquiry: "Inquiry",
          suggestion: "Suggestion",
          name: "Name",
          email: "Email",
          phone: "Phone",
          message: "Message",
          submit: "Submit",
          loading: "Submitting...",
          error: "All fields are required."
        }
      },
      reportRequest: {
        title: "Request Laboratory Reports",
        instructions: "Please fill out the form below to request your laboratory reports.",
        fullName: "Full Name",
        email: "Email",
        phone: "Phone Number",
        visitTime: "Visit Time",
        submit: "Submit"
      },
      withdrawal: {
        header: "Home Withdrawal",
        instructions: "Please fill out the form below to schedule a home withdrawal.",
        fullName: "Full Name",
        email: "Email",
        phone: "Phone Number",
        appointmentDate: "Choose Date",
        appointmentTime: "Choose Time",
        notes: "Notes",
        submit: "Submit",
        chooseId: "Choose Identity File",
        chooseInsurance: "Choose Insurance File"
      },
      booking: {
        header: "Booking",
        noPackageData: "No package data available. Please return to the previous page.",
        price: "Price",
        offerEnds: "Offer ends in",
        name: "Name",
        namePlaceholder: "Enter your name",
        email: "Email",
        emailPlaceholder: "Enter your email",
        phone: "Phone Number",
        phonePlaceholder: "Enter your phone number",
        notes: "Notes",
        notesPlaceholder: "Any additional notes",
        successMessage: "Booking request sent successfully!",
        errorMessage: "Error",
        generalErrorMessage: "An error occurred while sending the request. Please try again.",
        tests: "tests",
        submit: "Booking Now"
      },
      footer: {
        sections: [
          {
            header: "CMPL",
            links: [
              { label: "About Us", url: "/aboutPage" },
              { label: "Contact Us", url: "/contact" },
              { label: "Survey", url: "https://form.svhrt.com/690b19ee03886962930a9860" }
            ]
          },
          {
            header: "Our Services",
            links: [
              { label: "Offers", url: "/offer/" },
              { label: "Laboratory Reports Request", url: "/reports" },
              { label: "Home Withdrawal", url: "/withdraw" }
            ]
          },
          {
            header: "Support",
            links: [
              { label: "Medical Information", url: "/information" },
              { label: "Privacy Policy", url: "/privacypolicy" },
            ]
          }
        ],
        socialMedia: {
          apple: "Apple",
          facebook: "Facebook",
          twitter: "Twitter",
          shop: "Shop",
          whatsapp: "WhatsApp"
        },
        rights: {
          text: "All rights reserved by",
          companyName: "Central",
          companyName1: "Central",
          companyName2: "Medical  polyclinic",
          companyName3: " Laboratory",
          year: "2026 ©"
        }
      },
      "opinion": {
        "title": "Customer Reviews",
        "subheading": "We are proud of our customers' trust and experience",
        "google": "Google Reviews",
        "googleReviewButton": "Write a Review",
        "new": "New"
      },
      currency: "AED",
      discount: "Discount",
      day: "day",
      days: "days"
    }
  },
  ar: {
    translation: {
      loading: "جاري التحميل...",
      navbar: {
        home: "الرئيسية",
        packages: "الباقات",
        services: "الخدمات",
        offers: "العروض",
        location: "الموقع",
        about: "من نحن",
        contact: "تواصل معنا",
        testimonials: "الاراء",
        more: "المزيد"
      },
      home: {
        landingPage: {
          slides: [
            {
              header: "مختبرك الموثوق في خورفكان",
              content: "مختبر المجمع المركزي الطبي",
              labelBtn: "اكتشف المزيد"
            },
            {
              header: "معلومة طبية",
              content: "المعلومات الطبية الدقيقة هي أساس الوقاية. احرص على الحصول على المعلومات الصحيحة لاتخاذ قرارات صحية أفضل.",
              labelBtn: "اكتشف المزيد"
            },
            {
              header: "الباقات المميزة",
              content: "اكتشف الباقات التي نقدمها لتلبية احتياجاتك.",
              labelBtn: "اكتشف المزيد"
            }
          ],
          salesPackage: {
            header: "عروضنا الخاصة",
            discountTag: "{salePercent}% OFF",
            packageButton: "اكتشف العرض",
            noOffer: "لايوجد اي عروض"
          },
          partnerLogos: { title: "شركاء التأمين" }
        },
        info: {
          title: "لماذا نحن؟",
          features: [
            {
              title: "نسعى للريادة في التميز.",
              description: "قطعنا شوطاً كبيراً من رحلتنا للتميز فقد ارتفع سقف طموحنا وأصبحنا نسعى للريادة في التميز.",
              icon: "running"
            },
            {
              title: "الأكثر تنافسية وإنتاجية",
              description: "الأكثر تنافسية وإنتاجية لجميع المعنيين من خلال الاستمرار في أسلوب عملنا المبتكر والمستمر والمستدام.",
              icon: "recycle"
            },
            {
              title: " خدمات وتحاليل طبية عاليةالجودة",
              description: "تقديم خدمات وتحاليل طبية عالية الجودة ودقيقة وبأسعار تنافسية لجميع الأشخاص المعنيين.",
              icon: "microscope"
            }
          ]
        },
        other: {
          contact: {
            button: "تواصل معنا",
            divider: "أو",
            locationTitle: "موقعنا",
            socialMediaHeader: "انضم إلى مجتمعنا على وسائل التواصل الاجتماعي",
            contactUs: "اتصل بنا:"
          },
          request: {
            tagline: "اتصل بنا",
            header: "هل لديك أي استفسار أو اقتراح؟",
            description: "ارسل الينا وسيتواصل معك  مجموعة من الخبراء",
            button: "اترك الرسالة"
          }
        }
      },
      services: {
        title: "خدماتنا",
        viewAll: "عرض الكل",
        description: "استكشف خدماتنا المتنوعة",
        service: [
          {
            id: 1,
            name_en: "معلومات طبية",
            description_en: "احصل على معلومات طبية عامة ودقيقة وحديثة لتعزيز وعيك الصحي.",
            icon: "info",
            path: "/information"
          },
          {
            id: 2,
            name_en: "طلب تقارير مخبرية",
            description_en: "تقديم طلب للحصول على تقارير مخبرية دقيقة وشاملة لجميع الفحوصات الطبية.",
            icon: "report",
            path: "/reports"
          },
          {
            id: 3,
            name_en: "السحب المنزلي",
            description_en: "خدمة السحب المنزلي تسمح لك بإجراء التحاليل في المنزل بكل راحة وسهولة.",
            icon: "home",
            path: "/withdraw"
          },
          {
            id: 4,
            name_en: "الباقات",
            description_en: "اكتشف الباقات الصحية المختلفة التي تغطي جميع احتياجات الفحوصات والعلاج بأسعار مميزة.",
            icon: "package",
            path: "/package"
          }
        ]
      },
      packages: {
        title: "الباقات المتاحة",
        description: "استعرض مجموعة من الباقات المصممة حسب احتياجاتك.",
        noPackages: "لا توجد باقات متاحة في هذه الفئة.",
        more: "المزيد",
        bookNow: "احجز الان",
        offer: "العروض الخاصة",
        test: "عدد الباقات",
        price: "السعر",
        onSale: "عرض ",
        salePrice: "سعر العرض",
        saleDuration: "مدة العرض",
        saleTimeLeft: "الوقت المتبقي",
        home: { more: "شاهد جميع الباقات" }
      },
      offer: {
        salesPackage: {
          header: "عروضنا الخاصة",
          description: "استكشف عروضنا الحصرية وخصوماتنا!",
          discountTag: "خصم"
        },
        packages: {
          noPackages: "لا توجد عروض متاحة في الوقت الحالي.",
          more: "المزيد من التفاصيل",
          bookNow: "احجز الآن"
        },
        start: "بداية العرض",
        end: "نهاية العرض",
        specialOffer: "العروض الخاصة",
        packageOffer: "عروض الباقات",
        test: "عدد الباقات",
        timeleft: "الوقت المتبقي",
        offerDuration: "مدة العرض"
      },
      survey: {
        title: "شارك في استطلاع الرأي الخاص بنا",
        description: "نود أن نسمع رأيك. الرجاء تخصيص لحظة لإكمال استطلاعنا.",
        start: "ابدأ الاستطلاع"
      },
      details: {
        tests: "الباقات",
        details: "تفاصيل",
        currentPrice: "السعر الحالي",
        originalPrice: "السعر الأصلي",
        discount: "خصم",
        offerEndsIn: "ينتهي العرض خلال",
        price: "السعر",
        bookNow: "احجز الآن",
        testsNumber: "عدد الباقات",
        testsNumberSale: "عدد باقات العرض",
        start: "بداية العرض",
        end: "نهاية العرض",
        offerDuration: "مدة العرض",
        timeLeft: " ينتهي العرض خلال ",
        specialOffer: "عرض خاص",
        onSale: "تخفيض باقة",
        expird: "انتهي"
      },
      medicalInformation: {
        title: "معلومات طبية",
        description: "احصل على معلومات طبية محدثة بشكل دوري لتحسين صحتك وعافيتك.",
        generalTab: "معلومات طبية عامة",
        weeklyTab: "معلومات الأسبوع",
        noData: "لا توجد بيانات متاحة",
        availableInfo: "معلومة الاسبوع",
        noWeeklyInfo: "لا توجد معلومات متاحة لهذا الأسبوع."
      },
      months: {
        january: "يناير",
        february: "فبراير",
        march: "مارس",
        april: "أبريل",
        may: "مايو",
        june: "يونيو",
        july: "يوليو",
        august: "أغسطس",
        september: "سبتمبر",
        october: "أكتوبر",
        november: "نوفمبر",
        december: "ديسمبر"
      },

      about: {
        title: "من نحن",
        description: "مختبركم الموثوق في خورفكان",
        story: {
          title: "قصتنا",
          text: "انطلقت رحلتنا بخبرة بدأت منذ عام 2018، حين اجتمع فريق من الأطباء والفنيين المتخصصين لتقديم خدمات مخبرية دقيقة وموثوقة تخدم مجتمع خورفكان. واليوم، نواصل هذه المسيرة من خلال مختبرنا الجديد، معتمدين على أحدث التقنيات وأعلى معايير الجودة والسلامة، لنقدّم نتائج دقيقة وسريعة تُسهم في دعم القرار الطبي وتحسين صحة المجتمع. مختبرنا ليس مجرد مكان للفحوصات، بل شريك صحي حيث نضع ثقة المرضى في مقدمة أولوياتنا"
        },
        vision: {
          title: "رؤيتنا",
          text: "أن نكون المختبر الطبي الرائد والأكثر موثوقية في خورفكان والمنطقة، من خلال تقديم خدمات تشخيصية دقيقة وموثوقة تسهم في تعزيز جودة الرعاية الصحية وتحسين صحة المجتمع، بالاعتماد على الابتكار وأعلى المعايير العالمية."
        },

        mission: {
          title: "رسالتنا",
          text: "تقديم خدمات مخبرية دقيقة وسريعة وموثوقة باستخدام أحدث التقنيات وكفاءات طبية متخصصة، مع الالتزام التام بسلامة المرضى وسرية معلوماتهم، ودعم القرار الطبي وبناء شراكات صحية طويلة الأمد مع المجتمع."
        },

        values: {
          title: "قيمنا",
          text: "1. الدقة والموثوقية\n 2- الثقة والنزاهة\n 3-الجودة والسلامة\n4- العمل الجماعي والخبرة\n. 5-خدمة المجتمع"
        },
        "team": { "title": "فريقنا" }
      },
      "location": {
        "title": "موقعنا",
        "description": "ندعوك لزيارتنا واستكشاف خدماتنا",
        "addressTitle": "العنوان",
        "country": "الإمارات العربية المتحدة",
        "governorate": "إمارة الشارقة",
        "city": "خورفكان",
        "scheduleTitle": "مواعيد العمل",
        "BeforeIftar": "قبل الإفطار",
        "AfterIftar": "بعد الإفطار",
        "schedule": {
          "days": [
            "السبت",
            "الأحد",
            "الإثنين",
            "الثلاثاء",
            "الأربعاء",
            "الخميس"
          ],
          "morning": "الفترة الصباحية",
          "evening": "الفترة المسائية",
          "morningTime": "9 صباحًا إلى 1 مساءً",
          "eveningTime": "5 مساءً إلى 9 مساءً",
          "daily": "من السبت إلى الخميس",
          "dailyTime": " 9 صباحًا إلى 1 مساءً & 5 مساءً إلى 9 مساءً",
          "monday": "الإثنين",
          "mondayTime": "من 9 صباحًا إلى 1 مساءً & 5 مساءً إلى 9 مساءً",
          "friday": "الجمعة",
          "fridayTime": "أجازة"
        },
        "viewPackages": "استعرض باقاتنا"

      }
      ,
      contact: {
        header: "تواصل معنا",
        subHeader: "تواصل عبر الشبكات الاجتماعية",
        address: {
          title: "العنوان",
          location: "الشارقة , خورفكان"
        },
        social: {
          facebook: "فيس بوك",
          whatsapp: "وتس آب",
          instagram: "انستجرام",
          phone: "رقم الاتصال",
          email: "البريد الالكتروني",
          address: "العنوان",
          tiktock: "تيك توك",
          snapshat: "سناب شات"
        },
        form: {
          inquiry: "استفسار",
          suggestion: "اقتراح",
          name: "الاسم",
          email: "البريد الالكتروني",
          phone: "رقم الجوال",
          message: "ملاحظات",
          submit: "إرسال",
          loading: "جاري الإرسال...",
          error: "جميع الحقول مطلوبة."
        }
      },
      reportRequest: {
        title: "لطلب التقارير المخبرية",
        instructions: "يرجى ملء النموذج أدناه لتقديم طلب للحصول على تقاريرك المخبرية.",
        fullName: "الاسم الكامل",
        email: "البريد الإلكتروني",
        phone: "رقم الجوال",
        visitTime: "وقت الزيارة",
        submit: "إرسال"
      },
      withdrawal: {
        header: "طلب سحب من المنازل",
        instructions: "يرجى ملء النموذج أدناه لتحديد موعد السحب المنزلي.",
        fullName: "الاسم الكامل",
        email: "البريد الإلكتروني",
        phone: "رقم الجوال",
        appointmentDate: "تحديد موعد",
        appointmentTime: "وقت موعد",
        notes: "ملاحظات",
        submit: "إرسال",
        chooseId: "اختر ملف الهوية",
        chooseInsurance: "اختر ملف التأمين"
      },
      booking: {
        header: "الحجز",
        noPackageData: "لا توجد بيانات الحزمة. يرجى العودة للصفحة السابقة.",
        price: "السعر",
        offerEnds: "ينتهي العرض خلال",
        name: "الاسم",
        namePlaceholder: "أدخل اسمك",
        email: "البريد الالكتروني",
        emailPlaceholder: "أدخل بريدك الالكتروني",
        phone: "رقم الجوال",
        phonePlaceholder: "أدخل رقم جوالك",
        notes: "ملاحظات",
        notesPlaceholder: "أي ملاحظات إضافية",
        successMessage: "تم إرسال الطلب بنجاح!",
        errorMessage: "خطأ",
        generalErrorMessage: "حدث خطأ أثناء إرسال الطلب. حاول مرة أخرى.",
        tests: "فحص",
        submit: "احجز الان"
      },
      footer: {
        sections: [
          {
            header: "CMPL",
            links: [
              { label: "من نحن", url: "/aboutPage" },
              { label: "تواصل معنا", url: "/contact" },
              { label: "إستبيان أراء المتابعين", url: "https://form.svhrt.com/690b19ee03886962930a9860" }
            ]
          },
          {
            header: "خدماتنا",
            links: [
              { label: "العروض", url: "/offer" },
              { label: "التحاليل المخبرية", url: "/reports" },
              { label: "السحب المنزلي", url: "/withdraw" }
            ]
          },
          {
            header: "الدعم",
            links: [
              { label: "معلومات طبية", url: "/information" },
              { label: "سياسة الخصوصية", url: "/privacypolicy" },
            ]
          }
        ],
        socialMedia: {
          apple: "آبل",
          facebook: "فيسبوك",
          twitter: "تويتر",
          shop: "متجر",
          whatsapp: "واتساب",
          tiktock: "تيك توك",
          snapshat: "سناب شات"
        },
        rights: {
          text: " جميع الحقوق محفوظة لـ",
          companyName1: "مختبر",
          companyName2: " المجمع المركزي ",
          companyName3: " الطبي",
          year: "2026 ©"
        }
      },
      "opinion": {
        "title": "آراء عملائنا",
        "subheading": "نفتخر بثقة عملائنا وتجربتهم معنا",
        "google": "تقييمات Google",
        "googleReviewButton": "اكتب تقييمك الآن",
        "new": "جديد"
      },
      currency: "درهم إماراتي",
      discount: "الخصم",
      day: "يوم",
      days: "أيام"
    }
  }
};

const savedLanguage = localStorage.getItem('language') || 'eng';

i18n.use(initReactI18next).init({
  resources,
  lng: savedLanguage,
  fallbackLng: 'eng',
  interpolation: {
    escapeValue: false
  }
});

export default i18n;
